import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import api from "../../util/api";

const initialState = {
  createMeetingPoint: {
    loading: false,
  },
  importMeetingPoint: {
    loading: false,
  },
  getMeetingPoint: {
    loading: false,
    data: [],
    pagination: {
      page: 1,
      pageSize: 10,
      totalItems: 0,
    },
  },
  deleteMeetingPoint: {
    loading: false,
  },
  editMeetingPoint: {
    loading: false,
  },
  searchAndGetMeetingPoint: {
    loading: false,
    data: [],
  },
  deleteAllMeetingPoint: {
    loading: false,
  },
  deleteSelectedMeetingPoint: {
    loading: false,
  },
};

//MeetingPoint API call
const asyncCreateMeetingPoint = createAsyncThunk(
  "admin/createMeetingPoint",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post("/api/meetingpoints/create", payload);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncImportMeetingPoint = createAsyncThunk(
  "admin/importMeetingPoint",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post("/api/meetingpoints/import", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncGetMeetingPoint = createAsyncThunk(
  "admin/getMeetingPoint",
  async (payload, { rejectWithValue }) => {
    const {
      page = 1,
      limit = 10,
      sortByColumn = "",
      sortOrder = "",
      q = "",
    } = payload;
    try {
      const response = await api.get(
        `/api/meetingpoints?page=${page}&limit=${limit}&sortByColumn=${sortByColumn}&sortOrder=${sortOrder}&q=${q}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncDeleteMeetingPoint = createAsyncThunk(
  "admin/deleteMeetingPoint",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/api/meetingpoints/${payload}`);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncEditMeetingPoint = createAsyncThunk(
  "admin/editMeetingPoint",
  async (payload, { rejectWithValue }) => {
    const { id, ...restPayload } = payload;
    try {
      const response = await api.put(`/api/meetingpoints/${id}`, restPayload);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncSearchAndGetMeetingPoint = createAsyncThunk(
  "admin/searchAndGetMeetingPoint",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/meetingpoints/search`);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncDeleteAllMeetingPoint = createAsyncThunk(
  "admin/deleteAllMeetingPoint",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/api/meetingpoints/delete-all`);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncDeleteSelectedMeetingPoint = createAsyncThunk(
  "admin/deleteSelectedMeetingPoint",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/api/meetingpoints/delete-many`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

export const meetingPointSlice = createSlice({
  name: "meetingPoint",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create meetingPoint
    builder.addCase(asyncCreateMeetingPoint.pending, (state) => {
      state.createMeetingPoint = {
        loading: true,
      };
    });
    builder.addCase(asyncCreateMeetingPoint.fulfilled, (state) => {
      state.createMeetingPoint = {
        loading: false,
      };
    });
    builder.addCase(asyncCreateMeetingPoint.rejected, (state) => {
      state.createMeetingPoint = {
        loading: false,
      };
    });
    // import meetingPoint
    builder.addCase(asyncImportMeetingPoint.pending, (state) => {
      state.importMeetingPoint = {
        loading: true,
      };
    });
    builder.addCase(asyncImportMeetingPoint.fulfilled, (state) => {
      state.importMeetingPoint = {
        loading: false,
      };
    });
    builder.addCase(asyncImportMeetingPoint.rejected, (state) => {
      state.importMeetingPoint = {
        loading: false,
      };
    });
    // get meetingPoint
    builder.addCase(asyncGetMeetingPoint.pending, (state) => {
      state.getMeetingPoint = {
        loading: true,
        data: state.getMeetingPoint.data || [],
        pagination: state.getMeetingPoint.pagination,
      };
    });
    builder.addCase(asyncGetMeetingPoint.fulfilled, (state, action) => {
      state.getMeetingPoint = {
        loading: false,
        data: action.payload.data.results || [],
        pagination:
          action.payload.data.pagination || state.getMeetingPoint.pagination,
      };
    });
    builder.addCase(asyncGetMeetingPoint.rejected, (state) => {
      state.getMeetingPoint = {
        loading: false,
        data: [],
        pagination: {
          page: 1,
          pageSize: 10,
          totalItems: 0,
        },
      };
    });
    // delete meetingPoint
    builder.addCase(asyncDeleteMeetingPoint.pending, (state) => {
      state.deleteMeetingPoint = {
        loading: true,
      };
    });
    builder.addCase(asyncDeleteMeetingPoint.fulfilled, (state) => {
      state.deleteMeetingPoint = {
        loading: false,
      };
    });
    builder.addCase(asyncDeleteMeetingPoint.rejected, (state) => {
      state.deleteMeetingPoint = {
        loading: false,
      };
    });
    // edit meetingPoint
    builder.addCase(asyncEditMeetingPoint.pending, (state) => {
      state.editMeetingPoint = {
        loading: true,
      };
    });
    builder.addCase(asyncEditMeetingPoint.fulfilled, (state) => {
      state.editMeetingPoint = {
        loading: false,
      };
    });
    builder.addCase(asyncEditMeetingPoint.rejected, (state) => {
      state.editMeetingPoint = {
        loading: false,
      };
    });
    // search and get terminal
    builder.addCase(asyncSearchAndGetMeetingPoint.pending, (state) => {
      state.searchAndGetMeetingPoint = {
        loading: true,
        data: state.searchAndGetMeetingPoint.data || [],
      };
    });
    builder.addCase(
      asyncSearchAndGetMeetingPoint.fulfilled,
      (state, action) => {
        state.searchAndGetMeetingPoint = {
          loading: false,
          data:
            action.payload.data.results || state.searchAndGetMeetingPoint.data,
        };
      }
    );
    builder.addCase(asyncSearchAndGetMeetingPoint.rejected, (state) => {
      state.searchAndGetMeetingPoint = {
        loading: false,
        data: [],
      };
    });
    // delete all meetingPoint
    builder.addCase(asyncDeleteAllMeetingPoint.pending, (state) => {
      state.deleteAllMeetingPoint = {
        loading: true,
      };
    });
    builder.addCase(asyncDeleteAllMeetingPoint.fulfilled, (state) => {
      state.deleteAllMeetingPoint = {
        loading: false,
      };
    });
    builder.addCase(asyncDeleteAllMeetingPoint.rejected, (state) => {
      state.deleteAllMeetingPoint = {
        loading: false,
      };
    });
    // delete selected meetingPoint
    builder.addCase(asyncDeleteSelectedMeetingPoint.pending, (state) => {
      state.deleteSelectedMeetingPoint = {
        loading: true,
      };
    });
    builder.addCase(asyncDeleteSelectedMeetingPoint.fulfilled, (state) => {
      state.deleteSelectedMeetingPoint = {
        loading: false,
      };
    });
    builder.addCase(asyncDeleteSelectedMeetingPoint.rejected, (state) => {
      state.deleteSelectedMeetingPoint = {
        loading: false,
      };
    });
  },
});

export {
  asyncCreateMeetingPoint,
  asyncImportMeetingPoint,
  asyncGetMeetingPoint,
  asyncDeleteMeetingPoint,
  asyncEditMeetingPoint,
  asyncSearchAndGetMeetingPoint,
  asyncDeleteAllMeetingPoint,
  asyncDeleteSelectedMeetingPoint,
};

export default meetingPointSlice.reducer;
